<template>
  <div class="font-proxima-nova">
    <ul>
      <li>
        <router-link
          @click.native="mtm('Bostad')"
          :class="{ active: value == RENTALOBJECT_TYPES.APARTMENT }"
          :to="{ name: 'Search', params: { type: 'bostad' } }">
          Bostad
        </router-link>
      </li>
      <li>
        <router-link
          @click.native="mtm('Student')"
          :class="{ active: value == RENTALOBJECT_TYPES.STUDENT_APARTMENT }"
          :to="{ name: 'Search', params: { type: 'studentbostader' } }">
          Studentbostad
        </router-link>
      </li>
      <li>
        <router-link
          @click.native="mtm('Fordonsplatser')"
          :class="{ active: value == RENTALOBJECT_TYPES.PARKING }"
          :to="{ name: 'Search', params: { type: 'fordonsplatser' } }">
          Fordonsplats
        </router-link>
      </li>
      <li>
        <router-link
          @click.native="mtm('Förråd')"
          :class="{ active: value == RENTALOBJECT_TYPES.PREMISE }"
          :to="{ name: 'Search', params: { type: 'forrad' } }">
          Förråd
        </router-link>
      </li>
      <!-- <li>
        <router-link @click.native="mtm('Odlingslott')" :class="{ active: value == RENTALOBJECT_TYPES.CULTIVATION }"
                     :to="{ name: 'Search', params: { type: 'odlingslott'}}">Odlingslott
        </router-link>
      </li>-->
    </ul>
  </div>
</template>
<script>
import { RENTALOBJECT_TYPES } from '@/config/constants';
import { dataLayerPush } from '@/helpers/datalayer';

export default {
  props: ['value'],
  data() {
    return {
      types: {
        apartment: 'Bostäder',
        parking: 'Fordonsplatser',
        premise: 'Förråd',
        //cultivation: 'Odlingslott',
      },
      RENTALOBJECT_TYPES: RENTALOBJECT_TYPES,
    };
  },
  watch: {
    // '$route.params.type':{
    //   handler(to, from){
    //     if(to == 'bostad')
    //       this.change('apartments')
    //     else if(to == 'fordonsplatser')
    //       this.change('parkings');
    //     else if(to == 'forrad')
    //       this.change('premises')
    //     else if(to == 'studentbostader')
    //       this.change('studentapartments')
    //   },
    //   immediate:true
    // }
  },
  methods: {
    change(type) {
      this.$emit('change', type); // för att kunna lyssna på change
      this.$emit('input', type); // för v-model support
    },

    mtm(txt) {
      dataLayerPush({ event: 'flikSortering', buttonText: txt });
    },
  },
};
</script>

<style lang="scss" scoped>

ul {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;

  @media (min-width: 500px) {
    overflow-x: hidden;
  }
}

li {
  display: block;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: 0.08px;
  border: none;
  margin-right: 0;

  &:first-of-type a {
    padding-left: 0;
    padding-right: 0;
    margin-right: 14px;

    @media (min-width: 500px) {

    }
  }

  a {
    font-weight: bold;
    text-decoration: none;
    color: $darkgray;
    display: block;
    padding: 14px 10px;

    @media (min-width: 500px) {
      padding: 14px 19px;
    }

    &.active, &.router-link-active {
      color: $abgblue;
      border-bottom: 2px solid $abgblue;
    }
  }
}

</style>
